import styled, { css } from 'styled-components';

import { Button, breakpoints, theme } from '@notino/react-styleguide';

interface Variant {
  isVariant2: boolean;
}

const mediaMdStyles = ({ isVariant2 }) =>
  isVariant2 &&
  css`
    margin-top: -0.5rem;
    margin-bottom: 1.5rem;
    flex-direction: row;
  `;

const mediaLgStyles = ({ isVariant2 }) =>
  isVariant2 &&
  css`
    margin: 0;
    margin-bottom: 3rem;
    flex-direction: row;
  `;

export const SkinAnalyserWrapper = styled.div<Variant>`
  padding: 0.5rem;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  border-radius: 0.5rem;
  box-shadow: 0px 1px 2px 0px rgba(71, 71, 71, 0.06),
    0px 4px 8px 0px rgba(71, 71, 71, 0.1);

  cursor: ${({ isVariant2 }) => (isVariant2 ? ' default' : 'pointer')};

  ${({ isVariant2 }) =>
    isVariant2 &&
    css`
      flex-direction: column;
      padding: 0;
      margin-top: -0.5rem;
      margin-bottom: 1.5rem;
    `}

  @media (min-width: ${breakpoints.md}) {
    margin: 0.5rem 0;

    ${mediaMdStyles}
  }

  @media (min-width: ${breakpoints.lg}) {
    ${mediaLgStyles}
  }
`;

export const ImageVariant1 = styled.img`
  width: 6.25rem;
  height: 6.25rem;
`;

export const ImageVariant2 = styled.img`
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    width: 23.31rem;
  }
`;

export const DescriptionAndActionWrapper = styled.div<Variant>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;

  ${({ isVariant2 }) =>
    isVariant2 &&
    css`
      padding: 1.25rem 1rem;
      gap: 0.5rem;
      flex: initial;

      @media (min-width: ${breakpoints.md}) {
        padding: 1.25rem;
      }
    `}
`;

export const StyledButton = styled(Button)`
  margin-top: 0.5rem;

  @media (min-width: ${breakpoints.md}) and (max-width: ${breakpoints.lg}) {
    width: 50%;
    margin-top: 0.75rem;
  }
  @media (min-width: ${breakpoints.xl}) {
    width: 50%;
  }
`;

export const StyledTitle = styled.span<Variant>`
  ${({ isVariant2 }) => css`
    ${theme.typography[isVariant2 ? 'titleSmall' : 'labelRegular']}
    font-size: ${isVariant2 ? '1.125rem' : '0.875rem'};
  `}
`;
export const StyledDescription = styled.span<Variant>`
  ${({ isVariant2 }) =>
    theme.typography[isVariant2 ? 'bodyRegular' : 'labelRegular400']}

  color: ${theme.color.text.secondary};
`;
